import type { components } from "@/api-schema";
import { VehicleBuyInConfigurationErrorCode } from "@/api-schema-enums";
import { isAxiosError } from "axios";
import i18next from "i18next";

const ERROR_TRANSLATION_KEYS = {
  [VehicleBuyInConfigurationErrorCode.PaperlessWorkspaceIdMissing]: "fab:VehicleBuyInPaperlessWorkspaceIdMissing",
  [VehicleBuyInConfigurationErrorCode.PaperlessWorkspaceIdInvalid]: "fab:VehicleBuyInPaperlessWorkspaceIdInvalid",
  [VehicleBuyInConfigurationErrorCode.PaperlessTemplateIdMissing]: "fab:VehicleBuyInPaperlessTemplateIdMissing",
  [VehicleBuyInConfigurationErrorCode.PaperlessTemplateIdInvalid]: "fab:VehicleBuyInPaperlessTemplateIdInvalid",
} as const satisfies Record<VehicleBuyInConfigurationErrorCode, string>;

type VehicleBuyInConfigurationErrorResponse = components["schemas"]["VehicleBuyInConfigurationErrorResponseDto"];

function isVehicleBuyInConfigurationErrorResponse(value: unknown): value is VehicleBuyInConfigurationErrorResponse {
  if (!value || typeof value !== "object") {
    return false;
  }

  const candidate = value as Partial<VehicleBuyInConfigurationErrorResponse>;
  return (
    Object.values(VehicleBuyInConfigurationErrorCode).includes(
      candidate.errorCode as VehicleBuyInConfigurationErrorCode,
    ) &&
    typeof candidate.message === "string" &&
    candidate.statusCode === 422
  );
}

export function resolveVehicleBuyInCreateErrorDescription(error: unknown): string | null {
  if (!isAxiosError(error) || error.response?.status !== 422) {
    return null;
  }

  const responseData = error.response.data;
  if (!isVehicleBuyInConfigurationErrorResponse(responseData)) {
    return null;
  }

  return i18next.t(ERROR_TRANSLATION_KEYS[responseData.errorCode]);
}
